/* === CRO Cart Page — force the drawer to render inline on /cart === */
(function () {
  if (!document.body.classList.contains('is-cart-page')) return;
  if (window.__CRO_CART_PAGE_LOADED__) return;
  window.__CRO_CART_PAGE_LOADED__ = true;

  // The drawer element exists in theme layout. We just need it to be in its "active" state
  // visually (so renderDrawer fills it) — but our CSS hides the overlay so it looks inline.
  function activateInline(){
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawer.classList.add('active');
    drawer.classList.add('cro-cart-page-mode');
    // Move drawer INTO main so it renders between header and footer (not above header)
    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (main && drawer.parentElement !== main) {
      main.insertBefore(drawer, main.firstChild);
    }
    // Trigger re-render
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', activateInline);
  } else {
    activateInline();
  }
  // Re-activate after any cart change
  document.addEventListener('cart:updated', activateInline);
})();
